var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32214 11.7987L25.8926 11.7987L20.7383 16.953C20.0403 17.651 20.0403 18.7785 20.7383 19.4765C21.4362 20.1745 22.5638 20.1745 23.2617 19.4765L31.4765 11.2617C32.1745 10.5638 32.1745 9.43624 31.4765 8.73825L23.2617 0.52349C22.5638 -0.174497 21.4362 -0.174497 20.7383 0.52349C20.0403 1.22148 20.0403 2.34899 20.7383 3.04698L25.8926 8.21924L2.32214 8.21924C1.33781 8.21924 0.532435 9.0246 0.532435 10.0089C0.532435 10.9933 1.33781 11.7987 2.32214 11.7987Z",
    fill: "#2B4E7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.1f3dfd7d8ec100767f5961c8c6209f85.svg";
export { ForwardRef as ReactComponent };